import {differenceInCalendarMonths, differenceInYears, format} from "date-fns";

/**
 * Formats an interval (date range) into a string, omitting parts as
 * appropriate.
 *
 * @example
 * formatInterval(new Date('2025-05-01'), new Date('2025-05-01')) // 1 May 2025
 * formatInterval(new Date('2025-05-01'), new Date('2025-05-03')) // 1-3 May 2025
 * formatInterval(new Date('2025-04-31'), new Date('2025-05-01')) // 30 Apr - 1 May 2025
 * formatInterval(new Date('2025-05-01'), new Date('2026-05-01')) // 1 May 2025 - 1 May 2026
 *
 * @param {number|Date|string} a The start (earlier) date of the interval
 * @param {number|Date|string} [b] The end (later) date of the interval
 * @returns string
 */
export function formatInterval(a, b) {
    if (!b || a === b) {
        // Dates are the same or no end date
        // Returns something like "3 May 2025"
        return format(b, 'd MMM y');
    }
    else if (differenceInCalendarMonths(b, a) === 0) {
        // Dates are in the same month
        // Returns something like "3-4 May 2025"
        return `${format(a, 'd')}-${format(b, 'd MMM y')}`;
    }
    else if (differenceInYears(b, a) === 0) {
        // Dates are in the same year
        // Returns something like "30 May - 2 Jun 2025"
        return `${format(a, 'd MMM')} - ${format(b, 'd MMM y')}`;
    }
    else {
        // Dates are in different years
        // Returns something like "1 Dec 2025 - 1 Jan 2026"
        return `${format(a, 'd MMM y')} - ${format(b, 'd MMM y')}`;
    }
}